import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #C6C6C6',
    boxSizing: 'border-box',
    borderRadius: '4px',
    padding: '4px 8px',
    background: '#F5F6F8',
    fontSize: theme.size.sm,
    color: '#8F8F8F',
    flexShrink: 0
  },

  icon: {
    marginRight: '8px'
  },

  removeTagIcon: {
    marginLeft: '4px',
    cursor: 'pointer'
  },

  muiIcon: {
    height: 14,
    width: 14
  },

  tagIcon: {
    height: 12,
    width: 12
  }
}))

export default useStyles
